<template>
  <v-theme-provider>
    <base-section
      id="boards"
      space="40"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <base-section-heading title="Dewan Direksi" />
            <base-body space="0">
               <v-container fluid>
                <v-row dense>
                  <v-col
                    v-for="card in cards"
                    :key="card.name"
                    md="4"
                    xs="12"
                  >
                    <div 
                    data-aos="zoom-out"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="true"
                    data-aos-anchor-placement="top-center">
                    <v-hover v-slot="{ hover }">
                    <v-card
                    :elevation="hover ? 20 : 0"
                    :class="{ 'on-hover': hover }"
                    outlined>
                      <v-img
                        :src="require(`@/assets/${card.src}`)"
                        class="white--text align-end"
                        height="320px"
                        :gradient="hover ? '' : 'to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)'"
                        :alt="card.name"
                      >
                      <v-card-title class="body-1" v-text="card.name" v-if="hover===false"></v-card-title>
                      </v-img>
                      <v-card-actions>
                        <div  v-if="hover" class="caption" v-html="card.detail"> </div>
                        <div v-else>{{ card.title }}</div>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                    </div>
                  </v-col>
                  <v-col class="text-center mt-3">
                  <base-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    color="accent"
                    large
                    outlined
                    to="struktur-perusahaan"
                    v-if="$route.name === 'tentang-kami'"
                    class = "text-capitalize"
                  >
                    Struktur Perusahaan
                  </base-btn>
                </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBoards',
    data: () => ({
            posts: [],
            cards: [
              { name: 'Ihrom Bayu Aji', title: 'Direktur Utama', src: 'IhromBayu-nologo.png', detail: '<strong>Ihrom Bayu Aji, S.T., AAIK, Dipl. Ins., AIIS, CRMP, QIP, IPGD-GI. </strong> Lahir di Jakarta, 3 Februari 1977. Diangkat sebagai Direktur Utama berdasarkan Keputusan Anggota Dewan Komisioner Otoritas Jasa Keuangan tentang Hasil Penilaian Kemampuan dan Kepatutan Nomor KEP-298/NB.02/2023 tanggal 14 Juni 2023. Beliau juga menjabat sebagai Komite Pengembangan Produk di PT Asuransi Takaful Umum. Pendidikan terakhir S1 Sarjana Teknik Metalurgi Universitas Indonesia Tahun 2000. Saat ini beliau juga aktif sebagai Anggota Bidang Asuransi Kerugian AAMAI periode 2022-2025.' },
              { name: 'R. Melda Maesarach', title: 'Direktur Kepatuhan', src: 'Melda-nologo.png', detail: '<strong>R. Melda Maesarach, S.Pd., M.Si., AIIS, CRMP.</strong>  Lahir di Bandung, 9 Mei 1976. Menempuh pendidikan S1 di Universitas Pasundan Bandung dan S2 Magister Keuangan Syariah di STIE Ahmad Dahlan Jakarta pada tahun 2014. Aktif sebagai Dosen Prodi Ekonomi Islam Fakultas Ekonomi Bisnis Universitas Muhammadiyah Jakarta hingga sekarang. Saat ini, beliau menjabat sebagai Sekretaris Perusahaan, Ketua Komite Manajemen Risiko, serta Direktur Kepatuhan PT Asuransi Takaful Umum.' },
              { name: 'Darojat Yogi Candra', title: 'Direktur Operasional', src: 'DarojatYogi-nologo.png', detail: '<strong>Darojat Yogi Candra, S.E.As., AAAIK, AIIS, CRMO. </strong> Lahir di Purbalingga, 6 Januari 1979. Diangkat sebagai Direktur Operasional berdasarkan Keputusan Anggota Dewan Komisioner OJK Nomor KEP-40/NB.21/2022 tanggal 19 Agustus 2022. Selain itu, beliau juga menjabat sebagai Ketua Komite Investasi PT Asuransi Takaful Umum. Memiliki latar belakang pendidikan S1 Manajemen Asuransi Syariah dari STMA Trisakti.' },
            ],
        }),
  }
</script>